import { AppointmentStatus } from '../../models/appointment/Appointment'

const UNCLOSED_SESSION_APPOINTMENT_STATUSES: AppointmentStatus[] = ['newAppt', 'rescheduled']

/**
 * Whether an appointment's status means the session was never closed, so it still owes an invoice.
 *
 * For DA Engage providers `concluded` also counts: it is written when an on-platform video session
 * ends, before the session is closed, and treating it as closed let a legacy note be written for a
 * session that was never billed (ICE-7530). Other providers keep the original statuses, so their
 * calendar and task behaviour is unchanged.
 */
export const isUnclosedSessionStatus = (
  appointmentStatus: string | undefined,
  { isDAEngageProvider }: { isDAEngageProvider: boolean },
): boolean =>
  UNCLOSED_SESSION_APPOINTMENT_STATUSES.includes(appointmentStatus as AppointmentStatus) ||
  (isDAEngageProvider && appointmentStatus === 'concluded')

export enum CANCELATION_OPTIONS {
  'needMoreTime' = 'needMoreTime',
  'lookingOtherCareOptions' = 'lookingOtherCareOptions',
  'readyToGraduate' = 'readyToGraduate',
  'emergency' = 'emergency',
  'notFeelingWell' = 'notFeelingWell',
  'schedulingConflict' = 'schedulingConflict',
  'other' = 'other',
}

export const INITIAL_DAYS_OF_AVAILABILITY_SHOWN = 7
